export const createGetPersonalisedGeneratedPostsRequest = (page, per_page) => {
  return {
    url: "/personalised_generated_posts",
    method: "GET",
    params: {
      page,
      per_page,
    },
  };
};

export const createDiscardPersonalisedGeneratedPostsRequest = (
  generatedPostId
) => {
  return {
    url: `/personalised_generated_posts/${generatedPostId}`,
    method: "PUT",
    data: {
      status: "discarded",
    },
  };
};

export const createUsedPersonalisedGeneratedPostsRequest = (
  generatedPostId
) => {
  return {
    url: `/personalised_generated_posts/${generatedPostId}`,
    method: "PUT",
    data: {
      status: "used",
    },
  };
};
